import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import _ from 'lodash';
// import { message } from "antd";

const getProducts =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PRODUCT", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/product?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PRODUCT", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_PRODUCT",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PRODUCT", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const getProductById = (id) => (dispatch, getState) => {
    return axios
        .get(`/api/product/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const addProduct = (data) => async (dispatch, getState) => {
    const check = await Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to add product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    });

    if (check?.value) {
        data.setLoading(true);
        return axios
            .post("/api/product", data, tokenConfig(getState))
            .then((res) => {
                data.setLoading(false);
                if (res.data.status === 200) {
                    Swal.fire(t("Success"), t(res.data.message), "success")
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                data.setLoading(false);
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    }
};

const updateProduct = (data, setLoading) => async (dispatch, getState) => {
    const check = await Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to update product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    });

    if (check.value) {
        setLoading(true);
        return axios
            .put("/api/product", data, tokenConfig(getState))
            .then((res) => {
                setLoading(false);
                if (res.data.status === 200) {
                    Swal.fire(t("Success"), t(res.data.message), "success");
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    }
};

const deleteUpdateCategory = (data) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to update category product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            return axios
                .post("/api/product/update-categories", data, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        Swal.fire(t("Success"), t(res.data.message), "success");
                        return res.data.data;
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        }
    });
};

const changeProductCategory = (data, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Change category will reset product attributes."),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (!result.value) return false;
        if (setLoading) setLoading(true);
        return axios
            .post("/api/product/change-category", data, tokenConfig(getState))
            .then((res) => {
                if (setLoading) setLoading(false);
                if (res.data.status === 200) {
                    Swal.fire(t("Success"), t(res.data.message), "success");
                    return true;
                }
                Swal.fire(t("Error"), t(res.data.message), "error");
                return false;
            })
            .catch((err) => {
                if (setLoading) setLoading(false);
                Swal.fire(t("Error"), t("An error occurred!"), "error");
                return false;
            });
    });
};

const duplicateProduct = (data, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to duplicate product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setLoading(true);
            return Promise.all(
                data?.products?.map((v, i) => {
                    return new Promise(async (resolve2, reject2) => {
                        axios
                            .post(`/api/product/duplicate`, { id: v?._id, niche: data?.niche }, tokenConfig(getState))
                            .then((res) => {
                                if (res.data.status === 200) {
                                    resolve2(res.data.message)

                                } else {
                                    resolve2(res.data.message)
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                                resolve2(err)
                            });
                    });
                })).then(async (a) => {
                    setLoading(false);
                    Swal.fire(t("Success"), t("Product duplicate successfully!"), "success");
                    return true;
                })
        }
    });
};

const deleteProduct = (id, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to delete product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setLoading(true);
            if (Array.isArray(id)) {
                await Promise.all(
                    id?.map((i) => {
                        return new Promise(async (resolve2, reject2) => {
                            axios
                                .delete(`/api/product/${i}`, tokenConfig(getState))
                                .then((res) => {
                                    if (res.data.status === 200) {
                                        resolve2(res.data.message)

                                    } else {
                                        resolve2(res.data.message)
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                    resolve2(err)
                                });
                        });
                    })).then(async (a) => {
                        Swal.fire(t("Success"), t("Delete Success"), "success");
                        return true;
                    })
                setLoading(false);
            } else {
                return axios
                    .delete(`/api/product/${id}`, tokenConfig(getState))
                    .then((res) => {
                        setLoading(false);
                        if (res.data.status === 200) {
                            Swal.fire(t("Success"), t(res.data.message), "success");
                        } else {
                            Swal.fire(t("Error"), t(res.data.message), "error");
                        }
                        return true;
                    })
                    .catch((err) => {
                        setLoading(false);
                        Swal.fire(t("Error"), t("An error occurred!"), "error");
                        return false;
                    });
            }
        }
    });
};

const uploadProductToTiktok = (productId, shopId) => (dispatch, getState) => {
    return axios
        .post(`/api/product/tiktok`, { productId, shopId }, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success");
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const uploadProductToTiktokTool = (productId, shopId, saveMode, timeDelaySaveMode) => (dispatch, getState) => {
    return axios
        .post(`/api/product/tiktok`, { productId, shopId, saveMode, timeDelaySaveMode }, tokenConfig(getState))
        .then((res) => res.data)
        .catch((err) => err);
};

const uploadProductToTiktokToolv2 = (products, shops) => (dispatch, getState) => {
    return axios
        .post(`/api/product/tiktokv2`, { products, shops }, tokenConfig(getState))
        .then((res) => res.data)
        .catch((err) => err);
};

const uploadProductToTiktokToolv3 = (productId, shopId, saveMode, timeDelaySaveMode) => (dispatch, getState) => {
    return axios
        .post(`/api/product/tiktok-v3`, { productId, shopId, saveMode, timeDelaySaveMode }, tokenConfig(getState))
        .then((res) => res.data)
        .catch((err) => err);
};

const getProductsByShops =
    ({ page = 0, sizeperpage = 0, search = "", filter = {}, promotion_selected = "", shops_selected = [] } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PROMOTION", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`;
            var param_promotion_selected = "";
            if (promotion_selected !== "") {
                param_promotion_selected = `&promotion_selected=${promotion_selected}`;
            }
            var param_shops_selected = "";
            if (shops_selected.length > 0) {
                param_shops_selected = `&shops_selected=${shops_selected.join(",")}`;
            }
            axios
                .get(
                    `/api/product/list-products-by-shops?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}${param_promotion_selected}${param_shops_selected}`,
                    tokenConfig(getState)
                )
                .then((res) => {
                    dispatch({ type: "LOADING_PROMOTION", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "LIST_PRODUCTS_BY_SHOPS",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PROMOTION", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const syncProduct = (shops_selecteds = []) => (dispatch, getState) => {
    const chunk_shop = _.chunk(shops_selecteds, 1);
    const data_success = [];
    const data_err = [];
    return Promise.all(
        chunk_shop?.map((shops_selected) => {
            return new Promise(async (resolve2, reject2) => {
                var body = {
                    shops_selected
                }
                await axios
                    .post(`/api/product/sync`, body, tokenConfig(getState))
                    .then((res) => {
                        if (res.data.status === 200) {
                            data_success.push(res.data.message)
                            resolve2(res.data.message)
                        } else {
                            data_err.push(res.data.message)
                            resolve2(res.data.message)
                        }
                    })
                    .catch((err) => {
                        data_err.push(err)
                        resolve2(err)
                    });

            });
        })).then(async (a) => {
            Swal.fire(t("Success"), t(`Running sync product ${data_success.length}/ ${shops_selecteds.length} shops!`), "success");
            return true;
        })
}

const shareProductById = (email, product) => (dispatch, getState) => {
    return axios
        .post(`/api/product/share`, { product, email }, tokenConfig(getState))
        .then((res) => res.data)
        .catch((err) => {
            return;
        });
};

const createProductsByTemplate = (data) => async (dispatch, getState) => {
    const check = await Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to create list product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    });

    if (check.value) {
        if (data?.setIsLoadingImport) data?.setIsLoadingImport(true);

        const { setIsLoadingImport, data: items, ...payloadBase } = data || {};
        const products = Array.isArray(items) ? items : [];
        if (!products.length) {
            if (data?.setIsLoadingImport) data?.setIsLoadingImport(false);
            Swal.fire(t("Error"), t("Data invalid"), "error");
            return false;
        }

        // Chế độ "default" xử lý attribute bằng AI cho từng sản phẩm nên gửi tuần tự
        // từng sản phẩm một, tránh rate limit AI và timeout HTTP. Các chế độ khác
        // không đụng AI nên gộp tất cả vào 1 lệnh cho nhanh.
        const perProduct = payloadBase?.attribute_products === "default";
        const batches = perProduct ? products.map((product) => [product]) : [products];

        let successCount = 0;
        let lastMessage = "";
        const failedMessages = [];

        for (const batch of batches) {
            if (!batch.length) continue;
            const label = batch.length === 1 ? batch[0]?.title || "" : "";
            try {
                const res = await axios.post(
                    "/api/product/create-by-template",
                    { ...payloadBase, data: batch },
                    tokenConfig(getState)
                );
                lastMessage = res.data.message;
                if (res.data.status === 200) {
                    successCount += batch.length;
                } else {
                    failedMessages.push(label ? `${label}: ${res.data.message}` : res.data.message);
                }
            } catch (err) {
                const message = t("An error occurred!");
                failedMessages.push(label ? `${label}: ${message}` : message);
            }
        }

        if (data?.setIsLoadingImport) data?.setIsLoadingImport(false);

        if (!failedMessages.length) {
            Swal.fire(
                t("Success"),
                perProduct ? `${successCount}/${products.length} ${t("products created!")}` : t(lastMessage || ""),
                "success"
            );
            return true;
        }

        Swal.fire(
            successCount > 0 ? t("Warning") : t("Error"),
            (perProduct ? `${successCount}/${products.length} ${t("products created!")}\n` : "") +
                failedMessages.slice(0, 5).join("\n"),
            successCount > 0 ? "warning" : "error"
        );
        return successCount > 0;
    } else {
        return false;
    }
};

const changeProductByTemplate = (data) => (dispatch, getState) => {
    return axios
        .post(`/api/product/change-by-template`, data, tokenConfig(getState))
        .then((res) => res.data)
        .catch((err) => {
            return;
        });
};

const createProductById = (id, setLoadingPage) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to create product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        setLoadingPage(true)
        if (result.value) {
            if (Array.isArray(id)) {
                return Promise.all(
                    id?.map((i) => {
                        return new Promise(async (resolve2, reject2) => {
                            axios
                                .post(`/api/product/create-by-id`, { id: i }, tokenConfig(getState))
                                .then((res) => {
                                    if (res.data.status === 200) {
                                        resolve2({ status: true, message: res.data.message, id: i })
                                    } else {
                                        resolve2({ status: false, message: res.data.message, id: i })
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                    resolve2({ status: false, message: err.message, id: i })
                                });
                        });
                    })).then(async (a) => {
                        const errs = a.filter((r) => !r.status);
                        if (errs.length) {
                            Swal.fire(t("Error"), `${errs.map((err) => `<p>${err.id}: ${err.message}</p>`).join("")}`, "error");
                            return;
                        }
                        setLoadingPage(false)
                        Swal.fire(t("Success"), t("Create Success"), "success");
                        return true;
                    })
            } else {
                return axios
                    .post(`/api/product/create-by-id`, { id }, tokenConfig(getState))
                    .then((res) => {
                        if (res.data.status === 200) {
                            Swal.fire(t("Success"), t(res.data.message), "success");
                        } else {
                            Swal.fire(t("Error"), t(res.data.message), "error");
                        }
                        setLoadingPage(false)
                        return true;
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire(t("Error"), t("An error occurred!"), "error");
                        setLoadingPage(false)
                        return false;
                    });
            }
        }
        setLoadingPage(false)
    });
};

const saveEditProduct = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id,
        title: data?.title,
    };

    // Swal.fire({
    // 	title: t("Are you sure?"),
    // 	text: t("Are you sure to edit order?"),
    // 	icon: 'warning',
    // 	showCancelButton: true,
    // 	confirmButtonColor: '#3085d6',
    // 	cancelButtonColor: '#d33',
    // 	confirmButtonText: t("Sure"),
    // 	cancelButtonText: t("Cancel")
    // }).then((result) => {
    // 	if (result.value) {
    dispatch({ type: 'LOADING_PRODUCT', payload: true });
    axios.post('/api/product/edit', body, tokenConfig(getState)).then(res => {
        dispatch({ type: 'LOADING_PRODUCT', payload: false });
        if (res.data.status === 200) {
            dispatch(getProducts({ page: data.page, sizeperpage: data.sizeperpage, search: data.search, filter: data.filter }));
            // Swal.fire(t("Success"), t(res.data.message), 'success');
        } else {
            Swal.fire(t("Error"), t(res.data.message), 'error');
        }
    }).catch(err => {
        dispatch({ type: 'LOADING_PRODUCT', payload: false });
        Swal.fire(t("Error"), t("An error occurred!"), 'error');
    });

    // 	}
    // })
};
const changePublicProduct = (data) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to change product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            return axios
                .post("/api/product/change-public", data, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        Swal.fire(t("Success"), t(res.data.message), "success");
                        return res.data.data;
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        }
    });
};
const loadDropShippingList = (data) => (dispatch, getState) => {
    dispatch({ type: 'LOADING_PRODUCT', payload: true });
    return axios
        .post("/api/product/dropshipping", data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                dispatch({ type: 'LOADING_PRODUCT', payload: false });
                return res?.data?.data?.result || [];
            } else {
                dispatch({ type: 'LOADING_PRODUCT', payload: false });
                return [];
            }
        })
        .catch((err) => {

            dispatch({ type: 'LOADING_PRODUCT', payload: false });
            return [];
        });
};

const getProductSuggests =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/product/suggest?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_PRODUCT_SUGGEST",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const changeVariantByCSV = (data, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to update variants?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            setLoading(true);
            return axios
                .post("/api/product/variants-by-csv", data, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        setLoading(false);
                        Swal.fire(t("Success"), t(res.data.message), "success");
                        return [];
                    } else {
                        setLoading(false);
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        }
    });
};

const getOrdersTeam =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/product/orders-team?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_PRODUCT_SUGGEST",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PRODUCT_SUGGEST", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const exportProducts =
    ({ search = "", filter = {} } = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: "LOADING_PRODUCT", payload: true });

            let page = 1;
            const sizeperpage = 1000;
            let allData = [];
            let hasMore = true;

            // var param_search = "";
            // if (search !== "") {
            //     param_search = `&search=${search}`;
            // }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            try {
                while (hasMore) {
                    const res = await axios
                        .post(`/api/product/export?page=${page}&sizeperpage=${sizeperpage}${filter}`, { search }, tokenConfig(getState));
                    if (res.data.status !== 200) {
                        throw new Error(res.data.message);
                    }

                    const data = res.data.data.all_products_for_export;
                    allData = [...allData, ...data];

                    if (data.length < sizeperpage) {
                        hasMore = false;
                    } else {
                        page++;
                    }
                }

                dispatch({
                    type: "EXPORT_PRODUCT",
                    payload: { all_products_for_export: allData },
                });
            } catch (err) {
                // console.log(err);
                Swal.fire("Error", "Export failed!", "error");
            } finally {
                dispatch({ type: "LOADING_PRODUCT", payload: false });
            }
        };

const deleteProductByDuplicateSku = (id, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to delet product by duplicate sku?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setLoading(true);
            if (Array.isArray(id)) {
                await Promise.all(
                    id?.map((i) => {
                        return new Promise(async (resolve2, reject2) => {
                            axios
                                .delete(`/api/product/duplicate-sku/${i}`, tokenConfig(getState))
                                .then((res) => {
                                    if (res.data.status === 200) {
                                        resolve2(res.data.message)

                                    } else {
                                        resolve2(res.data.message)
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                    resolve2(err)
                                });
                        });
                    })).then(async (a) => {
                        Swal.fire(t("Success"), t("Delete Success"), "success");
                        return true;
                    })
                setLoading(false);
            } else {
                return axios
                    .delete(`/api/product/duplicate-sku/${id}`, tokenConfig(getState))
                    .then((res) => {
                        setLoading(false);
                        if (res.data.status === 200) {
                            Swal.fire(t("Success"), t(res.data.message), "success");
                        } else {
                            Swal.fire(t("Error"), t(res.data.message), "error");
                        }
                        return true;
                    })
                    .catch((err) => {
                        setLoading(false);
                        Swal.fire(t("Error"), t("An error occurred!"), "error");
                        return false;
                    });
            }
        }
    });
};

const productEditInformationsMulti = (data, setLoading) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to edit informations product?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setLoading(true);
            await axios
                .post("/api/product/edit-informations", { ...data }, tokenConfig(getState))
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === 200) {
                        Swal.fire("Success", res.data.message, "success");
                    } else {
                        Swal.fire("Error", res.data.message, "error");
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Swal.fire("Error", "An error occurred!", "error");
                });
        }
    });
};

export {
    getProducts,
    addProduct,
    deleteProduct,
    getProductById,
    updateProduct,
    uploadProductToTiktok,
    getProductsByShops,
    uploadProductToTiktokTool,
    syncProduct,
    uploadProductToTiktokToolv2,
    deleteUpdateCategory,
    changeProductCategory,
    shareProductById,
    duplicateProduct,
    changeProductByTemplate,
    createProductsByTemplate,
    createProductById,
    uploadProductToTiktokToolv3,
    saveEditProduct,
    changePublicProduct,
    getProductSuggests,
    loadDropShippingList,
    changeVariantByCSV,
    getOrdersTeam,
    exportProducts,
    deleteProductByDuplicateSku,
    productEditInformationsMulti,
};
